import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Screens from "./screens";
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

if (process.env.REACT_APP_STAGE === 'prod' &&
  process.env.NODE_ENV === 'production') {
  LogRocket.init(process.env.REACT_APP_LOG_ROCKET_APP_ID);
  setupLogRocketReact(LogRocket);
}

ReactDOM.render(
  <React.StrictMode>
    <Screens />
  </React.StrictMode>,
  document.getElementById("root")
);
